import { IconProps } from './types';

export const HideIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20.658 16.527'>
    <path
      // eslint-disable-next-line max-len
      d='M10.329,12.911a4.631,4.631,0,0,1-4.613-4.3L2.331,6A10.758,10.758,0,0,0,1.145,7.792a1.044,1.044,0,0,0,0,.942,10.353,10.353,0,0,0,9.184,5.726,10.026,10.026,0,0,0,2.514-.338l-1.675-1.3a4.652,4.652,0,0,1-.839.084Zm10.13,1.875-3.568-2.758a10.692,10.692,0,0,0,2.623-3.295,1.044,1.044,0,0,0,0-.942,10.353,10.353,0,0,0-9.184-5.726A9.947,9.947,0,0,0,5.574,3.283L1.467.109A.516.516,0,0,0,.742.2l-.634.816A.516.516,0,0,0,.2,1.74L19.191,16.418a.516.516,0,0,0,.725-.091l.634-.816a.516.516,0,0,0-.091-.725ZM14.529,10.2,13.26,9.223A3.059,3.059,0,0,0,9.512,5.287a1.538,1.538,0,0,1,.3.911,1.506,1.506,0,0,1-.05.323L7.387,4.684a4.594,4.594,0,0,1,2.942-1.069,4.646,4.646,0,0,1,4.648,4.648,4.538,4.538,0,0,1-.449,1.94Z'
      transform='translate(0 0)'
      fill='#fff'
      {...props}
    />
  </svg>
);
